import React from "react";
import { useTranslation } from "react-i18next";
import MuscleDiagramCard from "../../../../dashboard/calendar/components/MuscleDiagramCard";
import { displayDateRange } from "../../../../../utils/questionnaire";

const WorkloadStats = ({ start, end }) => {
  const { t } = useTranslation("athlete-portal");
  return (
    <article id="summary-muscle-diagram">
      <header>
        <h4>{t("bodyComposition.workload.title")}</h4>
        <p className="p4">{displayDateRange(start, end)}</p>
      </header>
      <div className="workload-content">
        <MuscleDiagramCard isComposition={true} />
      </div>
    </article>
  );
};

export default WorkloadStats;
